// React
import { React, useState } from 'react';
import reactGA from 'react-ga';

// MUI
import {
  Container,
  CssBaseline,
  Box,
  Grid,
  Typography,
  Button,
  Tooltip
} from '@mui/material';

// Components
import images from '../../../assets/img';

// Data
import { portalSections } from '../../../data/portalsData';

import i18next from 'i18next';

// CSS
import styles from './company-details-section.module.scss';

export default function CompanyDetailsSection({ sectionDetails }) {
  const [play, setPlay] = useState(false);

  const displayVideoSection = () => {
    return (
      <>
        {play ? (
          <video
            className={`${styles['company-details-section-video']}`}
            controls
            autoPlay
            playsInline
          >
            <source
              src={`${process.env.REACT_APP_CDN_LINK}/ms-public-images/MobilityMarketplaceDemo.mp4`}
              type='video/mp4'
            />
            <track kind='captions' src='' label={i18next.t('NO_CAPTIONS')} />
          </video>
        ) : (
          <Tooltip title={i18next.t('SHARED.PLAY_VIDEO')}>
            <Box
              component='img'
              src={images.playButton}
              onClick={() => {
                setPlay(true);
                reactGA.event({
                  category: 'Home Screen Video Play',
                  action: 'User Clicked on Play Button',
                  label: 'Home Screen Video Play'
                });
              }}
              alt={i18next.t('IMAGE_ALT_TEXT.CAMPAIGN_SECTION.PLAYBACKIMG')}
              className={`${styles['company-details-section-image']}`}
            />
          </Tooltip>
        )}
      </>
    );
  };

  return (
    <>
      <CssBaseline />
      <Box
        className={`${styles['company-details-section-wrapper']}`}
        pt={10}
        pb={10}
        px={6}
        sx={{ backgroundColor: 'primaryBackground.bgBody' }}
      >
        <Container>
          <Grid container md={6} sm={12} xs={12}>
            <Grid
              item
              md={12}
              sm={12}
              xs={12}
              className={`${styles['company-details-section-heading-wrapper']}`}
            >
              <Typography
                className={`${styles['company-details-section-heading']}`}
                component='h1'
                variant='h5'
              >
                {i18next.t(sectionDetails.title)}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            md={12}
            sm={12}
            xs={12}
            className={`${styles['company-details-section-grid-container']}`}
          >
            <Grid
              container
              md={6}
              xs={12}
              className={`${styles['company-details-section-features-wrapper']}`}
            >
              <Grid
                item
                md={12}
                xs={12}
                className={`${styles['company-details-section-content-container']}`}
              >
                <Typography
                  className={`${styles['company-details-section-content']}`}
                >
                  {i18next.t(sectionDetails.body)}
                </Typography>
              </Grid>
              <Grid
                container
                md={12}
                xs={12}
                sm={12}
                className={`${styles['company-details-section-btn-container']}`}
                spacing={1}
              >
                <Grid
                  item
                  md={12}
                  mt={3}
                  sm={12}
                  xs={12}
                  pt={20}
                  className={`${styles['company-details-section-btn-wrapper']}`}
                >
                  <Button
                    variant='borderedBtn'
                    href={sectionDetails.redirectionUrl}
                    target={sectionDetails.target}
                    onClick={() => {
                      reactGA.event(sectionDetails.reactGAEvents);
                    }}
                  >
                    {i18next.t(sectionDetails.button)}
                  </Button>
                </Grid>
              </Grid>
            </Grid>
            <Grid
              container
              md={6}
              xs={12}
              className={`${styles['company-details-section-video-container']}`}
            >
              <Grid
                item
                md={12}
                xs={12}
                className={`${styles['company-details-section-video-wrapper']}`}
              >
                {sectionDetails.id === portalSections[0].id && displayVideoSection()}
                {sectionDetails.id === portalSections[1].id && (
                  <Box
                    component='img'
                    src={images.mobility}
                    className={`${styles['company-details-section-image']}`}
                  ></Box>
                )}
              </Grid>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </>
  );
}
